import { StatusIndicator } from "@amzn/awsui-components-react";
import { ToolCallState } from "features/assistant/definitions";
import styles from "./style.module.scss";

interface ToolCallIndicatorProps {
  toolCall: ToolCallState & { description?: string };
}

// Keep in sync with tools registered in
// AmazonGaiaAgents gaia_assistant/tools/__init__.py
const TOOL_DISPLAY_NAMES: Record<string, string> = {
  search_audits: "Searching audits",
  search_notices: "Searching notices",
  search_litigations: "Searching litigations",
  search_tasks: "Searching tasks",
  search_assessments: "Searching assessments",
  search_payments: "Searching payments",
  search_drafts: "Searching drafts",
  search_reviews: "Searching reviews",
  search_entity: "Searching entities",
  search_employees: "Searching employees",
  search_tax_areas: "Searching tax areas",
  search_gaia_kb_documents: "Searching Gaia knowledge base documents",
  ask_answers: "Searching Answers knowledge base",
  get_approval_context: "Fetching approval context",
  get_gaia_object_details: "Fetching details",
  get_outcome_breakdown_instructions: "Fetching outcome breakdown instructions",
  get_draft_scan_result: "Fetching draft scan results",
  extract_draft_fields: "Extracting draft fields",
  extract_document_fields: "Extracting document fields",
  summarize_documents: "Summarizing documents",
  summarize_draft: "Summarizing draft",
  read_document: "Reading document",
  read_draft: "Reading draft",
  read_file_attachment: "Reading file attachment",
  add_file_attachment_to_gaia_object: "Attaching file",
  update_task: "Updating task",
  create_agent_action_review: "Creating action review",
  get_agent_action_review: "Fetching action review",
};

const statusTypeMap = {
  running: "loading",
  completed: "success",
  error: "error",
} as const;

const itemClassMap = {
  running: styles.toolCallItem,
  completed: `${styles.toolCallItem} ${styles.toolCallItemCompleted}`,
  error: `${styles.toolCallItem} ${styles.toolCallItemError}`,
};

const ToolCallIndicator: React.FC<ToolCallIndicatorProps> = ({ toolCall }) => {
  const displayName =
    TOOL_DISPLAY_NAMES[toolCall.toolName] || toolCall.toolName;
  return (
    <div className={itemClassMap[toolCall.status]}>
      <StatusIndicator type={statusTypeMap[toolCall.status]}>
        {displayName}
        {toolCall.description && `: ${toolCall.description}`}
      </StatusIndicator>
    </div>
  );
};

export default ToolCallIndicator;
